// Read-through cache del dato base de una mantención. Envuelve useAppApi('/mantenciones'):
// online → cachea el GET; offline → sirve el base guardado (sobre el que bindMantencion
// aplica el draft del checklist). Maneja su propio data/hasCalled para reflejar la rama offline.
import { useCallback, useState } from 'react';
import { useAppApi } from 'hooks/useAppApi';
import { saveMantencionBase, loadMantencionBase } from 'utils/offlineMantencionBaseStore';

export function useOfflineMantencionBase() {
  const map = useCallback((r) => r, []);
  const {
    isLoading,
    error,
    call: apiCall,
  } = useAppApi({
    baseUrl: '/mantenciones',
    mapResults: map,
  });

  const [data, setData] = useState(undefined);
  const [hasCalled, setHasCalled] = useState(false);

  const call = useCallback(
    async (idMantencion) => {
      setHasCalled(true);
      if (!navigator.onLine) {
        const cached = await loadMantencionBase(idMantencion);
        setData(cached ?? undefined);
        return cached;
      }
      const result = await apiCall({ extUrl: `/${idMantencion}` });
      if (result?.mantencion) {
        setData(result);
        await saveMantencionBase(idMantencion, result);
      } else {
        const cached = await loadMantencionBase(idMantencion);
        if (cached) setData(cached);
      }
      return result;
    },
    [apiCall]
  );

  return { data, isLoading, error, hasCalled, call };
}
